import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SupplierFilesComponent } from './supplier-files.component';

const routes: Routes = [
  {
    path: '',
    component: SupplierFilesComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SupplierFilesRoutingModule { }
